import React, { useState } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { startLoading, doneLoading } from '../../utils/loading'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import AppContext from '../../context/AppContext'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../components/forms/input/InputForm'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { GetMigrateEfin, SaveMigrateEfin } from '../../redux/actions/migrateEfin'

export default function MigrtedEFinWidget(props) {
  const { schema } = props
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [searchResult, setSearchResult] = useState()

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const handleSearch = async (projectCode, period) => {
    startLoading()
    setIsLoading(true)
    try {
      // setSearchResult(mockData)
      let response = await GetMigrateEfin(projectCode, period)

      if (response.model && !response.didError) {
        setSearchResult(response.model)

        notification.open('success', {
          title: `แสดงข้อมูลสำเร็จ`,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleProcess = async () => {
    startLoading()
    setIsLoading(true)
    setShowConfirm(false)
    try {
      let response = await SaveMigrateEfin(searchResult)

      if (response.model && !response.didError) {
        notification.open('success', {
          title: `ดำเนินการสำเร็จ`,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    //console.log('data', data)
    // let request = {
    //   projectCode: data.projectCode,
    //   period: data.period,
    // }

    handleSearch(data.projectCode, data.period)
  }

  return (
    <div>
      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        {isLoading && <OverlayLoader />}

        <Row>
          <Col xs={24} sm={1} md={2} lg={2}></Col>
          {schema.projectCode && (
            <Col xs={24} sm={11} md={10} lg={10}>
              <InputForm
                schema={schema.projectCode}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          )}
          {schema.period && (
            <Col xs={24} sm={11} md={10} lg={10}>
              <InputForm
                isInputNumber
                schema={schema.period}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          )}
          <Col xs={24} sm={1} md={2} lg={2}></Col>
        </Row>
        <Row style={{ marginTop: 20, textAlign: 'right' }}>
          <Col>
            <SearchButton onClick={handleSubmit(onSubmit)} />
          </Col>
        </Row>

        <hr />

        {searchResult && (
          <>
            <Row style={{ marginTop: 20 }}>
              <Col>
                <b>รหัสโครงการ : </b>
                {searchResult.projectCode}
              </Col>
              <Col>
                <b>ชื่อโครงการ : </b>
                {searchResult.projectName}
              </Col>
              <Col>
                <b>งวดที่ : </b>
                {searchResult.period}
              </Col>
            </Row>

            <Panel
              header={'รายรับ'}
              collapsible
              defaultExpanded
              bordered
              shaded
              style={{ marginTop: 20 }}
            >
              <Table
                style={{ marginTop: -10 }}
                wordWrap
                autoHeight
                // autoHeight={searchResult?.incomes?.length < 6}
                // height={400}
                data={searchResult?.incomes || []}
                loading={isLoading}
              >
                <Column align="center" width={100} fixed>
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.incomeType == 1) {
                        return index + 1
                      }
                    }}
                  </Cell>
                </Column>

                <Column minWidth={350} flexGrow={1}>
                  <HeaderCell>รายการ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.incomeType != 1) {
                        return (
                          <div style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {rowData.detail}
                          </div>
                        )
                      } else {
                        return <div>{rowData.detail}</div>
                      }
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>งบอนุมัติ</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.approveAmount)
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>ยอดปัจจุบัน</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.cerrentAmount)
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>ยอดสะสม</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.accumulatedAmount)
                    }}
                  </Cell>
                </Column>
              </Table>
            </Panel>

            <Panel
              header={'ค่าใช้จ่าย'}
              collapsible
              defaultExpanded
              bordered
              shaded
              style={{ marginTop: 20 }}
            >
              <Table
                style={{ marginTop: -10 }}
                wordWrap
                autoHeight
                //autoHeight={searchResult?.expenses?.length < 6}
                //height={400}
                data={searchResult?.expenses || []}
                loading={isLoading}
              >
                <Column align="center" width={100} fixed>
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.expenseType == 1) {
                        return index + 1
                      }
                    }}
                  </Cell>
                </Column>

                <Column minWidth={350} flexGrow={1}>
                  <HeaderCell>กิจกรรม</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.expenseType != 1) {
                        return (
                          <div style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {rowData.activity}
                          </div>
                        )
                      } else {
                        return <div>{rowData.activity}</div>
                      }
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>งบประมาณ</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.budgetAmount)
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>ยอดยกมา</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.broughtForwardAmount)
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>รายจ่ายจริง</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.expenseAmount)
                    }}
                  </Cell>
                </Column>
                <Column align="right" width={160}>
                  <HeaderCell>รายจ่ายสะสม</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.accumulatedAmount)
                    }}
                  </Cell>
                </Column>
              </Table>
            </Panel>

            <Panel
              header={'ยอดคงเหลือ'}
              collapsible
              defaultExpanded
              bordered
              shaded
              style={{ marginTop: 20 }}
            >
              <Table
                style={{ marginTop: -10 }}
                wordWrap
                autoHeight
                // autoHeight={searchResult?.remaining?.length < 6}
                //height={400}
                data={searchResult?.remaining || []}
                loading={isLoading}
              >
                <Column align="center" width={100} fixed>
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.remainType == 1) {
                        return index + 1
                      }
                    }}
                  </Cell>
                </Column>

                <Column minWidth={350} width={350} flexGrow={1}>
                  <HeaderCell>รายการ</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (rowData.remainType != 1) {
                        return (
                          <div style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {rowData.detail}
                          </div>
                        )
                      } else {
                        return <div>{rowData.detail}</div>
                      }
                    }}
                  </Cell>
                </Column>

                <Column align="right" width={160}>
                  <HeaderCell>ยอดเงิน</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return budgetFormat(rowData.amount)
                    }}
                  </Cell>
                </Column>
              </Table>
            </Panel>

            <Row style={{ marginTop: 20 }}>
              <Col style={{ textAlign: 'center' }}>
                <SaveButton
                  children="ดำเนินการ Migrate ข้อมูล"
                  disabled={isLoading}
                  onClick={() => {
                    setShowConfirm(true)
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={showConfirm}
        detail={`ยืนยันการ ${schema.header}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={handleProcess}
      />
    </div>
  )
}

// const mockData = {
//   projectCode: '67-01991',
//   projectName: 'โครงการ A',
//   incomes: [
//     {
//       detail: 'เงินสนับสนุนโครงการ',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 1,
//     },
//     {
//       detail: 'ค่าครุภัณฑ์โครงการ',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 1,
//     },
//     {
//       detail: 'ค่าตอบแทนคู่สัญญา',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 1,
//     },
//     {
//       detail: 'รวมรับเงินงวด',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 2,
//     },
//     {
//       detail: 'ภาณีหัก ณ. ที่จ่าย',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 3,
//     },
//     {
//       detail: 'รวมรายรับทั้งสิ้น',
//       approveAmount: 30000,
//       cerrentAmount: 30000,
//       accumulatedAmount: 30000,
//       incomeType: 4,
//     },
//   ],
//   expenses: [
//     {
//       activity: 'P01001',
//       budgetAmount: 30000,
//       broughtForwardAmount: 30000,
//       expenseAmount: 30000,
//       accumulatedAmount: 30000,
//       expenseType: 1,
//     },
//     {
//       activity: 'P01002',
//       budgetAmount: 30000,
//       broughtForwardAmount: 30000,
//       expenseAmount: 30000,
//       accumulatedAmount: 30000,
//       expenseType: 1,
//     },
//     {
//       activity: 'P01003',
//       budgetAmount: 30000,
//       broughtForwardAmount: 30000,
//       expenseAmount: 30000,
//       accumulatedAmount: 30000,
//       expenseType: 1,
//     },
//     {
//       activity: 'รวมรายรับทั้งสิ้น',
//       budgetAmount: 30000,
//       broughtForwardAmount: 30000,
//       expenseAmount: 30000,
//       accumulatedAmount: 30000,
//       expenseType: 4,
//     },
//   ],
//   remaining: [
//     {
//       detail: 'เงินสดในมือ',
//       amount: 30000,
//       remainType: 1,
//     },
//     {
//       detail: 'เงินฝากธนาคาร',
//       amount: 0,
//       remainType: 1,
//     },
//     {
//       detail: 'เงินยืมสํารองจากแหล่งอื่น',
//       amount: 0,
//       remainType: 1,
//     },
//     {
//       detail: 'ภาษีรอนำส่ง',
//       amount: 0,
//       remainType: 1,
//     },
//     {
//       detail: 'ค่าใช้จ่ายค้างจ่าย',
//       amount: 0,
//       remainType: 1,
//     },
//     {
//       detail: 'อื่นๆ ',
//       amount: 0,
//       remainType: 1,
//     },
//     {
//       detail: 'รวม ',
//       amount: 0,
//       remainType: 2,
//     },
//   ],
// }
